import React from 'react';

const EditableRow = ({ index, ...props }) => <tr {...props} />;

export default EditableRow;
